'use client';

import { Suspense } from "react";
import FormProcessDisplays from "@/components/features/FormProvider";
// import Footer from "@/components/layout/Footer";

export default function Home() {
  console.log('Home component rendering...');
  console.log('Environment variables:', {
    NEXT_PUBLIC_COGNITO_USER_POOL_CLIENT_ID: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_CLIENT_ID,
    NEXT_PUBLIC_COGNITO_DOMAIN: process.env.NEXT_PUBLIC_COGNITO_DOMAIN,
    NEXT_PUBLIC_API_ENDPOINT: process.env.NEXT_PUBLIC_API_ENDPOINT,
  });

  try {
    return (
      <div className="flex flex-col items-center gap-6 z-50 scale-90 md:scale-100">
        <div className="w-full max-w-3xl min-w-96">
          <Suspense fallback={
            <div className="glass-card p-8 mb-6 text-center flex flex-col items-center justify-center min-h-[200px]">
              <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite] mb-4"></div>
              <p className="text-gray-600">準備中...</p>
            </div>
          }>
            <FormProcessDisplays />
          </Suspense>
        </div>
        {/* <Footer /> */}
      </div>
    );
  } catch (error) {
    console.error('Home component error:', error);
    return (
      <div className="flex flex-col items-center gap-6 z-50 scale-90 md:scale-100">
        <div className="w-full max-w-3xl min-w-96">
          <div className="glass-card p-8 mb-6 text-center flex flex-col items-center justify-center min-h-[200px]">
            <p className="text-red-600">エラーが発生しました</p>
            <p className="text-gray-600">ページを再読み込みしてください</p>
          </div>
        </div>
      </div>
    );
  }
}